export const CustomPermissions = {
  Attachments: 'attachments',
  Authentication: 'authentication',
  Notes: 'notes',
  Notifications: 'notifications',
  Permissions: 'permissions',
  QrCode: 'qr_code',
  RelatedForms: 'personnel_related_forms',

  TaskTransitionCreate: 'create',
  TaskTransitionComplete: 'complete',

  ItemTrackerItemRequest: 'item_tracker_item_request',

  SafetyEventTransitionAssemble: 'assemble',
  SafetyEventTransitionPublish: 'publish',

  // Vendor specific permissions
  SignupUrl: 'signup_url',
  Insurance: 'insurance',
};
